import R from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import QuickSelect from './QuickSelect.jsx';
import { validations } from 'common';
import OrderedSelect from './OrderedSelect.jsx';
import { q2Questions } from './QuestionnairesData';

export default class Questionnaire2 extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
    this.editable = this.props.editable !== false;
    this.enableLeaveMessage();
  }
  componentDidUpdate() {
    this.enableLeaveMessage();
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }
  enableLeaveMessage() {
    if (this.props.canSave) {
      window.onbeforeunload = (event) => (event || window.event).returnValue = 'Tienes cambios sin guardar.'
    } else {
      window.onbeforeunload = null;
    }
  }
  render() {
    const complete = validations.finishedQuestionnaire2(this.props.value);
    const incompleteError = () => alert('Faltan campos de llenar.');
    let continueClasses = 'btn btn-lg btn-success';
    if (!complete) {
      continueClasses += ' disabled';
    }

    return (
      <form>
        <h1>Cuestionario 2</h1>
        <If condition={this.editable}>
          <div>
            <br />
            <p>1. En cada grupo palabras elige la palabra que <b style={{ color: '#5BC0DE' }}>MEJOR</b> te describe.</p>
            <p>2. De las tres palabras restantes elige la palabra que <b style={{ color: '#FF0000' }}>MENOS</b> te describe.</p>
            <p>Para cambiar la palabra, da click sobre la palabra seleccionada.</p>
            <br />
          </div>
        </If>
        {R.addIndex(R.map)(this.renderQuestion, q2Questions)}
        <If condition={this.editable}>
          <div style={{ textAlign: 'right' }}>
            <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className='btn btn-lg btn-info' disabled={!this.props.canSave} onClick={this.props.onSave}>{ this.props.canSave ? 'Guardar' : 'Guardado' }</button>
            <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className={continueClasses} onClick={complete ? this.props.onSubmit : incompleteError}>Continuar</button>
          </div>
        </If>
      </form>
    );
  }
  renderQuestion(options, index) {
    return (
      <div key={index} className='col-md-3 col-sm-4 col-xs-12'>
        <OrderedSelect editable={this.editable} selections={this.props.value[index]} options={options} text={index + 1 + '.'} onChange={this.handleSelectionChange(index)}/>
      </div>
    );
  }
  handleSelectionChange(index) {
    return (selections) => {
      this.props.onChange(R.adjust(R.always(selections), index, this.props.value));
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/questionnaires/Questionnaire2.jsx